module.exports = __webpack_public_path__ + "img/intersect.e6a02c77.jpg";